import { render } from "./App.vue?vue&type=template&id=5a15fba8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5a15fba8&lang=css"

import exportComponent from "/Users/hlw/Documents/HBuilderProjects/menhu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__